import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import FluentUiIcon from "../../../../assets/fluent-ui-icon";
import { FluentButton } from "../../../../components/FluentUI/Fluent-Button";
import { FluentTooltip } from "../../../../components/FluentUI/Fluent-Tooltip";
import "./organization.scss";

const Actions = ({ id, route, fetchEndpoint, type, canEdit, canArchive }) => {
    const history = useHistory();
    return (
        <div className="organization-badgename-container" data-testid="actions-container">
            <FluentTooltip data-testid="tooltip-Archive"
                target={
                    <FluentButton
                        disabled={!canArchive}
                        icon={<FluentUiIcon name={"ArchiveRegular"} size={18} disabled={!canArchive}/>}
                        onClick={async () => {
                            let DeletedIdsSelected = [];
                            DeletedIdsSelected.push(id);
                            await fetchEndpoint({Id: id, DeletedIdsSelected}, type);
                        }}
                    />
                }
                text="Archive"
            />
            <FluentTooltip data-testid="tooltip-Edit"
                target={
                    <FluentButton data-testid="loading-spinner"
                        disabled={!canEdit}
                        icon={<FluentUiIcon name={"EditRegular"} size={18} disabled={!canEdit}/>}
                        onClick={() => {
                            if (route?.length > 0) {
                                history.push(route)
                            }
                        }}
                    />
                }
                text="Edit"
            />
        </div>
    );
};

Actions.propTypes = {
    id: PropTypes.string,
    route: PropTypes.string,
    fetchEndpoint: PropTypes.func,
    type: PropTypes.string,
    canEdit: PropTypes.bool,
    canArchive: PropTypes.bool,
};

export default Actions;
